import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * "Nothing here" for lists, tables and search results: icon, a heading, a line of help,
 * and an optional action.
 *   <lb-empty-state icon="fa-truck" title="No shipments yet">Released orders show up here.</lb-empty-state>
 */
@Component({
  selector: 'lb-empty-state',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="lb-empty-state" [class.lb-empty-state-compact]="compact" role="status">
      <i *ngIf="icon" class="fa lb-empty-state-icon" [ngClass]="icon" aria-hidden="true"></i>
      <div class="lb-empty-state-title" *ngIf="title">{{ title }}</div>
      <div class="lb-empty-state-text"><ng-content></ng-content></div>
      <div class="lb-empty-state-actions"><ng-content select="[lbEmptyActions]"></ng-content></div>
    </div>
  `,
  styles: [`
    .lb-empty-state {
      text-align: center;
      padding: var(--lb-space-6) var(--lb-space-4);
      color: var(--lb-text-muted);
    }
    .lb-empty-state-compact {
      padding: var(--lb-space-4) var(--lb-space-3);
    }
    .lb-empty-state-icon {
      font-size: 2rem;
      color: var(--lb-border-strong);
      margin-bottom: var(--lb-space-2);
    }
    .lb-empty-state-compact .lb-empty-state-icon {
      font-size: 1.4rem;
    }
    .lb-empty-state-title {
      font-weight: 600;
      color: var(--lb-text);
      margin-bottom: var(--lb-space-1);
    }
    .lb-empty-state-text:empty,
    .lb-empty-state-actions:empty {
      display: none;
    }
    .lb-empty-state-actions {
      margin-top: var(--lb-space-3);
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: var(--lb-space-2);
    }
  `]
})
export class LbEmptyStateComponent {
  @Input() icon = 'fa-inbox';
  @Input() title = '';
  @Input() compact = false;
}
